var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 22.5049C17.523 22.5049 22 18.0279 22 12.5049C22 6.98188 17.523 2.50488 12 2.50488C6.477 2.50488 2 6.98188 2 12.5049C2 18.0279 6.477 22.5049 12 22.5049Z",
    stroke: "#E8E2F4",
    strokeWidth: 1.59513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 12.5049L11 14.5049L15 10.5049",
    stroke: "#E8E2F4",
    strokeWidth: 1.59513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleWhite);
export default __webpack_public_path__ + "static/media/check-circle-white.e3de57cd7c9b31885c2598e0504f7fff.svg";
export { ForwardRef as ReactComponent };